import { createContext } from 'react';
import _noop from 'lodash/noop';

export const DetectionTracksContext =
    createContext<DetectionTracksProviderValue>({
        addSongDataToDetectionTracks: _noop,
        detectionTracks: [],
        detectionStats: {
            detectionTracksCount: 0,
            detectionCapacity: null,
            enabled: {
                all: null,
                nonDraftOnly: null,
            },
            planType: null,
        },
        loading: false,
        refresh: 0,
        setDetectionTracks: _noop,
    });
